// Plugin.
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { useSelector } from 'react-redux';
// Component.
import PaymentDetails from './PaymentDetails';
import CancelDetails from './CancelDetails';
import UserDetail from '../UserDetail';
import HostClaimModal from '../../HostClaimModal/HostClaimModal';
import InquiryDetails from './InquiryDetails';
// Helpers and Actions.
import messages from '../../../locale/jsonMessages';
import { convert } from '../../../helpers/currencyConvertion';
import { formatTime } from '../../../helpers/formatting';
import { getDynamicTitle } from '../../../helpers/GetDynamicItemName/getDynamicName';
import { dateFormat } from '../../../config';
// Images.
import arrowIcon from '/public/SiteIcons/paymentArrow.svg';
// Styles.
import cs from '../../../components/commonStyle.css';
import s from '../ViewMessage.css';
import { formatLocalizedDate } from '../../../helpers/formatLocateDate';

const TripDetails = (props) => {
	const { title, startDate, endDate, personCapacity, listId, reservationData, startTime, endTime, refetchData } = props;
	const { basePrice, delivery, weeklyDiscount, monthlyDiscount, userType, currency, cancelData, currencyRates } = props;
	const { showModal, changeModalState, openModal, getInquiry } = props;
	const { profileId, picture, displayName, location, reviewsCount, verifications } = props;

	let formattedStartTime, formattedEndTime, checkIn, checkOut, startTimeValue, endTimeValue;
	let isCancelled = false, modalInitialValues = {}, checkOutDifference = 0, dynamicListTitle;

	const locale = useSelector(state => state?.intl?.locale);

	checkIn = formatLocalizedDate(startDate, locale, dateFormat?.displayDateFormat);
	checkOut = formatLocalizedDate(endDate, locale, dateFormat?.displayDateFormat);

	startTimeValue = reservationData?.startTime ? reservationData.startTime : startTime;
	endTimeValue = reservationData?.endTime ? reservationData.endTime : endTime;
	formattedStartTime = formatTime(startTimeValue);
	formattedEndTime = formatTime(endTimeValue);

	const dynamicTitle = useSelector(state => state?.dynamicListTitles?.data?.dynamicListTitle);
	dynamicListTitle = getDynamicTitle({ data: dynamicTitle, locale, id: listId });

	if (cancelData) {
		isCancelled = true;
	}

	if (reservationData) {
		modalInitialValues.securityDeposit = convert(currencyRates.base, currencyRates.rates, reservationData.securityDeposit, reservationData.currency, currencyRates.to).toFixed(2);
		if (reservationData.claimStatus && reservationData.claimStatus != 'pending') {
			modalInitialValues.claimAmount = convert(currencyRates.base, currencyRates.rates, reservationData.claimAmount, reservationData.currency, currencyRates.to).toFixed(2);
			modalInitialValues.claimReason = reservationData.claimReason;
			modalInitialValues.claimImages = reservationData.claimImages;
		}
		if (reservationData.reservationState == 'completed') checkOutDifference = moment().diff(moment(parseInt(reservationData.checkOut)), 'hour', true);
		if (cancelData && reservationData.reservationState == 'cancelled') {
			let todayDiff = moment().diff(moment(parseInt(reservationData.checkIn)), 'hour', true);
			if (todayDiff > 0) checkOutDifference = moment().diff(moment(parseInt(cancelData.createdAt)), 'hour', true);
		}
	}

	return (
		<div>
			{showModal && reservationData && <HostClaimModal
				refetchData={refetchData}
				claimed={Boolean(reservationData.claimStatus && reservationData.claimStatus != 'pending')}
				reservationId={reservationData.id}
				show={showModal}
				currency={reservationData.currency}
				changeModalState={changeModalState}
				initialValues={modalInitialValues}
			/>}
			<div>
				<div className={cx(s.marginBottom10)}>
					<h4 className={cx(cs.noMargin, s.tripDetails)}><FormattedMessage {...messages.tripDetails} /></h4>
				</div>
				<div>
					<a href={"/cars/" + listId} target="_blank" className={s.linkColor}>
						<h4 className={cx(s.noMargin, s.tripTitle)}>{dynamicListTitle || title}</h4>
					</a>
				</div>
			</div>
			<UserDetail
				profileId={profileId}
				picture={picture}
				displayName={displayName}
				location={location}
				reviewsCount={reviewsCount}
				verifications={verifications}
				userType={userType}
			/>
			<div>
				<hr className={s.horizondalLine} />
				<div className={s.displayGridDate}>
					<h5 className={cx(s.checkInText, s.marginTop0, s.space2)}>
						<span><FormattedMessage {...messages.checkIn} /></span>
					</h5>
					<span></span>
					<h5 className={cx(s.checkInText, s.marginTop0, s.space2)}>
						<span><FormattedMessage {...messages.checkOut} /></span>
					</h5>
				</div>
				<div className={s.displayGridDate}>
					<div>
						<p className={cx(s.checkInDt, s.space1)}>{checkIn}</p>
						<p className={cx(s.checkInDt, s.marginBottom0)}>{formattedStartTime}</p>
					</div>
					<span className={cx(s.tripArrowIconSec, s.justifySelf)}>
						<img src={arrowIcon} className={cx(s.dateArrowIcon, 'commonDateArrowRTLRotate')} />
					</span>
					<div>
						<p className={cx(s.checkInDt, s.space1)}>{checkOut}</p>
						<p className={cx(s.checkInDt, s.marginBottom0)}>{formattedEndTime}</p>
					</div>
				</div>
			</div>
			<div>
				{
					!isCancelled ?
						reservationData && <PaymentDetails
							userType={userType}
							startDate={parseInt(startDate)}
							endDate={parseInt(endDate)}
							startTime={reservationData.startTime}
							endTime={endTimeValue}
							basePrice={basePrice}
							delivery={delivery}
							weeklyDiscount={weeklyDiscount}
							monthlyDiscount={monthlyDiscount}
							currency={currency}
							reservationData={reservationData}
							checkOutDifference={checkOutDifference}
							openModal={openModal}
						/>
						:
						reservationData && <CancelDetails
							userType={userType}
							cancelData={cancelData}
							reservationData={reservationData}
							checkOutDifference={checkOutDifference}
							openModal={openModal}
						/>
				}
			</div>
			<div>
				{
					!reservationData && getInquiry &&
					<InquiryDetails
						userType={userType}
						getInquiry={getInquiry}
					/>
				}
			</div>
		</div>
	);
}

TripDetails.propTypes = {
	listId: PropTypes.number.isRequired,
	userType: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	startDate: PropTypes.string.isRequired,
	endDate: PropTypes.string.isRequired,
	personCapacity: PropTypes.number.isRequired,
	basePrice: PropTypes.number.isRequired,
	delivery: PropTypes.number.isRequired,
	currency: PropTypes.string.isRequired,
	monthlyDiscount: PropTypes.number,
	weeklyDiscount: PropTypes.number,
	cancelData: PropTypes.shape({
		guestServiceFee: PropTypes.number,
		hostServiceFee: PropTypes.number,
		refundToGuest: PropTypes.number,
		payoutToHost: PropTypes.number,
		total: PropTypes.number,
		currency: PropTypes.string,
	}),
	reservationData: PropTypes.any,
};

TripDetails.defaultProps = {
	title: '',
	startDate: null,
	endDate: null,
	personCapacity: 0,
	reservationData: null
};

export default withStyles(cs, s)(TripDetails);